import "../DiyIcvDigilockerSingleEducation/style.css";
import "../../assets/css/candidate-tab-form.css";
import SingleTab from "../../UI_Design/SingleTab/SingleTab";
import Education1 from "../DiyIcvDigilockerSingleEducation/Education/Education1";
import Education2 from "../DiyIcvDigilockerSingleEducation/Education/Education2";
// import Education3 from "../../Education/Education3";
import Education3 from "../DiyIcvDigilockerSingleEducation/Education/Education3"
// import "../../assets/css/"
import React, { useState, useEffect, useRef, useDebugValue } from "react";
import "../../assets/css/candidate-tab-form.css";
import _ from "lodash";
import "../../assets/css/inner-tabs.css";
import TickIconBlack from "../../assets/img/tick-icon-black.png";
import UploadIcon from "../../assets/img/upload-icon.svg";
import ExclamationIcon from "../../assets/img/exclamation-mark-icon.svg";

import { getData } from "../../Actions/landingAction";
//this is import just to grab upload file functionality
import { uploadFileViaMultipart } from "../../Actions/personalDetailsActions";
import ABSelect from "../Common/ABSelect";
import EDUCheckbox from "./eduCheckbox";
import EduSimpleSelect from "./eduSimpleSelect";
import Loader from "../Common/loader";
import { dateFormat } from "../../Helper/common";
import { dateFormat2 } from "../../Helper/common";
import {
  getEducation,
  addEducation,
  removeEducation,
  saveEducation,
  deleteSaveEducation,
} from "../../Actions/educationActions";
import { useDispatch, useSelector } from "react-redux";
import GetMasterData from "../../Helper/masterData";
import ABYear from "../Common/ABYear";
import ABDate from "../Common/ABDate";
import ABMonthYear from "../Common/ABMonthYear";
import ABUploadEdu from "../Common/ABUploadEdu";
import ABUploadEdu2 from "../Common/ABUploadEdu2";
import ABUploadEdu3 from "../Common/ABUploadEdu3";
import ABTextEdu from "../Common/ABTextEdu";
import ABCarousel from "../ABCarousel";
import "../../assets/css/custom-modal.css";
import "../../assets/css/rec-carousel.css";
import CustomPopUp from "../Common/customPopUp";
import { getCarousel } from "../../Actions/carouselAction";
import { useNavigate, useHistory } from "react-router-dom";
import ConfirmationPopup from "./confirmationPopup";
import DigilockerPopup from "./digilockerPopup";
import DigiSelect from "./digiSelect";
import EducationDigilocker from "../../Actions/Education-upload-via-digilocker";
import axios from "axios";
import {
  getDigiLockerFields,
  getDigiMoqList,
  getDigiUniversityList,
  verifyDigiLockerDocuments,
} from "../../Actions/DigiLockerActions";
// import { SelectR } from "react-select";
import Select from "react-select";
import MainForm from "./MainForm";
import MultiTabEdu from "./MultiTabEdu";
// import DigiLockerFields from "./digiLockerFields";
// import * as _ from 'lodash'

const MainFormDigiLockerNew = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    campusHire,
    showDigi,
    edu,
    active,
    reference,
    checkStatus,
    initialKey,
    showDigiRemovePopup,
    setShowDigiRemovePopup
  } = props;
  //alert(active);

  const [isLoading, setIsLoading] = useState(false);
  const [checked, setChecked] = React.useState(false);
  const [education, setEducation] = useState([]);
  //state used for form fields
  const [formVal, setFormVal] = useState({});
  const [formError, setFormError] = useState({});
  //state used for custom form fields that is formatted for sending data as per the api
  const [checkDataRecord, setCheckDataRecord] = useState({});

  const [newRecord, setNewRecord] = useState({});
  const [newValidationRecord, setNewValidationRecord] = useState({});

  const [activeTab, setActiveTab] = useState(0);
  const [showModal, setShowModal] = useState(0);
  const [maxDate, setMaxDate] = useState(null);
  const [errorMessage, setErrorMessage] = useState(false);
  //setting state for checkox
  // const handleChange = () => {
  //   setChecked(!checked);
  // };
  const [showRemovePopup, setShowRemovePopup] = useState(false);
  const [checkIdToBeRemoved, setCheckIdToBeRemoved] = useState(null);

  // states for new form
  const [showDigiPopup, setShowDigiPopup] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [moqOptions, setMoqOptions] = useState([]);
  const [allFields, setAllFields] = useState([]);
  const [allFieldsResponse, setAllFieldsResponse] = useState();
  const [univType,setUnivType] = useState('');
  const [digiResult, setDigiResult] = useState(false);
  const [activeTabEdu, setActiveTabEdu] = useState('')
  const [isOther, setIsOther] = useState(0);
  const [initialDataKey, setInitialDataKey] = useState(1);
  const [selectedCaseCheckId, setSelectedCaseCheckId] = useState(null);
  const [showAddPopup, setShowAddPopup] = useState(false);

  const handleChange = (value) => {
    setChecked(!checked);

    console.log("val", value);

    //this is state is for the purpose of storing data to the api
    setNewRecord((prevState) => ({
      ...prevState,
      [value[0].fieldId]: value[0].value,
    }));
    //this is state is for the purpose of storing data to the api

    //this is state is for validation purpose
    setNewValidationRecord((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));
    //this is state is for validation purpose

    // if (dataset.fieldname === "no_ssn") {
    //   let updatedNoSsn = _.cloneDeep(noSsnChecked);
    //   const updatedValue =
    //   updatedNoSsn[parseInt(dataset.checkdetailsindex)] === true
    //       ? ""
    //       : "checked";

    //   updatedNoSsn[parseInt(dataset.checkdetailsindex)] = !updatedNoSsn[parseInt(dataset.checkdetailsindex)];
    //   setNoSsn(updatedNoSsn);
    //   let scotDetails = _.cloneDeep(scotDisclosure);
    //   scotDetails.checksDetails[0].fields['ssn'].is_mandatory = 0;
    //   setScotDisc(scotDetails);
    // }

    updateEduDetails(
      value[0].checkdetailsindex,
      value[0].fieldname,
      value[0].value
    );
  };

  const [uploadedFilesCount, setUploadedFilesCount] = useState({});
  const [documnetMandatory, setDocumnetMandatory] = useState({});
  const [required_documents, setRequired_documents] = useState({});
  const [allResponseError, setAllResponseError] = useState({})

  //setting education data
  useEffect(() => {
    console.log("check", edu);

    setEducation(edu);
    setCatchIfAnyStatusIsNotCompleted(0);

    const checksDetails = edu.checksDetails;

    getUploadedFilesCount(checksDetails);
    getDocumentIdMandatory(checksDetails);
    createTabs(checksDetails);

  }, [edu]);

  useEffect(() => {
    if(initialKey){
      setInitialDataKey(initialKey);
    }
  }, [initialKey])

  // getting values to show in dropdowns
  const {
    degreeOptions,
    veridficationCourseNameOptions,
    qualificationOptions,
    modeOfQualificationOptions,
    digiLockerUniversityList,
  } = GetMasterData();



  //function to re-rener component
  const reRenderAgain = () => {
    props.reRenderAgain(education);
  };

  const reRenderAgain2 = () => {
    props.reRenderAgain2();
  };

  const updateEduDetails = (dataset, name, value) => {
    // alert(value);
    let eduDetails = _.cloneDeep(education);
    eduDetails.checksDetails[parseInt(dataset)].fields[name].field_value =
      value;
    console.log("ee", eduDetails);
    setEducation(eduDetails);
    // console.log("ee", education);
  };

  //cheking if any status is not completed
  const [catchIfAnyStatusIsNotCompleted, setCatchIfAnyStatusIsNotCompleted] =
    useState(0);
  useEffect(() => {
    if (
      typeof education.checksDetails !== "undefined" &&
      education.checksDetails !== null
    ) {
      if(education?.transation_id != ''){
        localStorage.setItem('digiTransId', JSON.stringify(education?.transation_id));
      }
      Object.entries(education.checksDetails).map(([key, value]) => {
        if (value.check_status === 2 || value.check_status === 3) {
          setCatchIfAnyStatusIsNotCompleted(0);
        } else {
          setCatchIfAnyStatusIsNotCompleted(1);
        }
      });
      console.log("this piece is running...",education)
    }
  }, [education]);

  useEffect(() => {
    console.log("this piece is also running...",catchIfAnyStatusIsNotCompleted)
  },[catchIfAnyStatusIsNotCompleted])

  const getUploadedFilesCount = (checksDetails) => {
    let uploadedFilesCount = {};
    for (let i in checksDetails) {
      let obj = {};
      for (let j in checksDetails[i].required_documents) {
        let count = 0;
        for (let k in checksDetails[i].uploaded_documents) {
          if (
            checksDetails[i].uploaded_documents[k].document_id ==
            checksDetails[i].required_documents[j].id
          ) {
            count++;
          }
        }
        obj[`${checksDetails[i].required_documents[j].id}`] = count;
      }
      uploadedFilesCount[i] = obj;
    }
    setUploadedFilesCount(uploadedFilesCount);
  };

  //alert(JSON.stringify(uploadedFilesCount));

  const getDocumentIdMandatory = (checksDetails) => {
    let uploadedFilesCount = {};
    for (let i in checksDetails) {
      let obj = {};
      for (let j in checksDetails[i].required_documents) {
        obj[
          `${checksDetails[i].required_documents[j].id}`
        ] = `${checksDetails[i].required_documents[j].is_mandatory}`;
      }
      uploadedFilesCount[i] = obj;
    }

    //alert(JSON.stringify(uploadedFilesCount));
    setDocumnetMandatory(uploadedFilesCount);

    //setRequired_documents
  };

  //alert(JSON.stringify(documnetMandatory));

  //for getting the info of fields taht is formatted as per the api format
  const textHandler = (value) => {
    console.log("fr", value);
    if (
      value[0].fieldname == "roll_no" ||
      value[0].fieldname == "grade_percentage" ||
      value[0].fieldname == "university_board_other"
    ) {
      //console.log("true");
      if (value[0].value.trim() == "") {
        value[0].value = "";
      }
    }
    var cols = document.getElementById(value[0].err_id);
    cols.innerHTML = "";
    //this is state is for the purpose of storing data to the api
    if(value[0].fieldname ==  'university_board_other'){
      setNewRecord((prevState) => ({
        ...prevState,
        [value[0].fieldId]: value[0].value,
        'university_board_other' : value[0].value,
        // 1
      }));
    // }
    }else{

      setNewRecord((prevState) => ({
        ...prevState,
        [value[0].fieldId]: value[0].value,
      }));
    }

    //this is state is for the purpose of storing data to the api

    //this is state is for validation purpose
    setNewValidationRecord((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));
    //this is state is for validation purpose

    //alert(JSON.stringify(value));
    // if(value[0].fieldname !=  'university_board_other')
    // updateEduDetails(
    //   value[0].checkdetailsindex,
    //   value[0].fieldname == 'university_board_other' ? 
    //   "university_board_other" : 
    //   value[0].fieldname,
    //   value[0].value
    // );

    updateEduDetails(
      value[0].checkdetailsindex, 
      value[0].fieldname,
      value[0].value
    );
  };

  //for getting the info of fields taht is formatted as per the api format
  const selectHandler = (value) => {
    console.log("fr", value);
    if (value[0].fieldname == "extra_remarks") {
      //console.log("true");
      if (value[0].value.trim() == "") {
        value[0].value = "";
      }
    }
    // alert(JSON.stringify(value))
    var cols = document.getElementById(value[0].err_id);
    cols.innerHTML = "";
    //this is state is for the purpose of storing data to the api
    setNewRecord((prevState) => ({
      ...prevState,
      [value[0].fieldId]: value[0].value,
    }));
    console.log(newRecord);
    //this is state is for the purpose of storing data to the api

    //this is state is for validation purpose
    setNewValidationRecord((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));
    //this is state is for validation purpose

    //alert(JSON.stringify(value));

    updateEduDetails(
      value[0].checkdetailsindex,
      value[0].fieldname,
      value[0].value
    );
    // updateEduDetails(value[0].checkdetailsindex, value[0].fieldname, value[0].value)
  };

  const universitySelectHandler = (value) => {
    var cols = document.getElementById(value[0].err_id);
    cols.innerHTML = "";
    //this is state is for the purpose of storing data to the api

    if (value[0].fieldname == "university_board") {
      setNewRecord((prevState) => ({
        ...prevState,
        [value[0].fieldId]: value[0].value.name,
        465: {}
      }));
      //this is state is for the purpose of storing data to the api
  
      //this is state is for validation purpose
      setNewValidationRecord((prevState) => ({
        ...prevState,
        [value[0].name]: value[0].value.name,
      }));
      setAllFields([]);
      setAllFieldsResponse({});
      setAllResponseError({});
    } 
    if (value[0].fieldname == "document_type") {
      setAllFields([]);
      setAllFieldsResponse({});
      setAllResponseError({});
      setNewRecord((prevState) => ({
        ...prevState,
        [value[0].fieldId]: {label: value[0].value.label, value: value[0].value.value },
      }));
      //this is state is for the purpose of storing data to the api
  
      //this is state is for validation purpose
      setNewValidationRecord((prevState) => ({
        ...prevState,
        [value[0].name]: value[0].value.label,
      }));
    }
   
    //this is state is for validation purpose
  if(value[0].fieldname == "university_board" && value[0].value.name == 'Other'){
    updateEduDetails(
      value[0].checkdetailsindex,
      value[0].fieldname,
      value[0].fieldname == 'university_board' ?
      value[0].value.name : 
      value[0].fieldname == 'document_type' ?
      {label: value[0].value.label, value: value[0].value.value} :
      value[0].value.label
      );
    }
      if (value[0].fieldname == "university_board") {
      // setIsDisabled(false);
      setAllFields([]);
      setAllFieldsResponse([]);
      console.log(newRecord);
      if(value[0].value.name == 'Other'){
        setUnivType('Other')
        setIsOther(1);
        // localStorage.setItem('isDigilocker',JSON.stringify(1));
      }else{ 
        setUnivType('')
        setIsOther(0);
        // localStorage.setItem('isDigilocker',JSON.stringify(1));
        dispatch(getDigiMoqList(value[0].value.value.id, callbackMoq));
        setIsLoading(true);
      }
    }

    if (value[0].fieldname == "document_type") {
      dispatch(
        getDigiLockerFields(value[0].value.value.doc_type_id, callbackFields)
      );
      setIsLoading(true);
    }

    // updateEduDetails(value[0].checkdetailsindex, value[0].fieldname, value[0].value)
  };

  const callbackMoq = (data) => {
    setIsDisabled(false);
    setMoqOptions(data);
    setIsLoading(false);
  };

  const callbackFields = (data) => {
    setAllFields(data);
    data.map((key) => {
      let label = key.paramname;
      setAllFieldsResponse((prev) => ({
        ...prev,
        [label] : ''
      }))
      setAllResponseError((prev) => ({
        ...prev,
        [label] : ''
      }))
    })
    setIsLoading(false);
  };

  console.log(allFieldsResponse);
  //on tab change set data for editing
  const tabChange = (index, caseCheckId) => {
    // alert("d");
    if (
      typeof education.checksDetails !== "undefined" &&
      education.checksDetails !== null
    ) {
      if (caseCheckId) {
        // reRenderAgain();
        navigate(`/case-initiation/check-detail/${reference}/3/${caseCheckId}`);
        //reRenderAgain();
      }
      Object.entries(education.checksDetails[index].fields).map(
        ([key, value]) => {
          if (value.id == 465) {
              if(allFields.length > 0){
                setNewRecord((prevState) => ({
                  ...prevState,
                  [value.id]: {label: value.field_value, value: value.field_value },
                }));
              }
              // else{
              //   setNewRecord((prevState) => ({
              //     ...prevState,
              //     [value.id]: {}
              //   }));
              // }
          }else{

            setNewRecord((prevState) => ({
              ...prevState,
              [value.id]: value.field_value,
            }));
          }  

          if (value.id == 52) {
            setChecked(value.field_value == 1 ? true : false);
          }
          if (value.id == 466 && initialDataKey == '1' ) {
              // setIsOther(value.field_value.toString());
              if(value.field_value == '1' || value.field_value == 1){
                setUnivType('Other') 
                setIsOther(1)
                let val = newRecord['135'];
                if(val && val != ''){
                  // setNewRecord((prevState) => ({
                  //   ...prevState,
                  //   "university_board_other" : val,
                  //   '135' : { value: "Other", label: "Other" }
                  // }));
                }
              }else{
                setUnivType(''); 
                setIsOther(0);

              }
            }

            if(value.id == 135 && value.field_value != ''){
              // setIsDisabled(false);
              setNewRecord((prevState) => ({
                      ...prevState,
                      464 : '',
                    }));
            }  
        }
      );
    }
  };


  //select option handler for getting non select handler
  const selectHandler2 = (value) => {
    var cols = document.getElementById(value[0].err_id);
    cols.innerHTML = "";
    setFormVal((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));
  };

  //on intial load  set data for editing in first tab
  useEffect(() => {
    if (
      typeof education.checksDetails !== "undefined" &&
      education.checksDetails !== null
    ) {
      console.log("sdsdsd");
      //finding which tab is active
      let activeTab = null;
      var tabs = document.getElementsByClassName("nav-link tab");
      for (let i = 0; i < tabs.length; i++) {
        if (tabs[i].classList.contains("active")) {
          activeTab = tabs[i].dataset.index;
        }
      }
      setActiveTabEdu(activeTab);
      // setAllFields([]);
      // setAllFieldsResponse({});
      setNewRecord({});

      if (activeTab == 0) {
        //reRenderAgain()  
        let allFieldsFlag = false;
        Object.entries(education.checksDetails[0].fields).map(
          ([key, value]) => {
            if(initialDataKey == 1){
              setInitialDataKey(0);
              if (value.id == 466) {
                  // setIsOther(value.field_value.toString());
                  if(value.field_value == '1' || value.field_value == 1){
                      setUnivType('Other') 
                      setIsOther(1);
                let val = newRecord['135'];
                if(val && val != ''){
                  // setNewRecord((prevState) => ({
                  //   ...prevState,
                  //   "university_board_other" : val,
                  //   // '135' : { value: "Other", label: "Other" }
                  // }));
                }
              }else{
                  setUnivType('');
                  setIsOther(0);
                }
              }  

              if (value.id == 464 && (value?.field_value != '' && value?.field_value != null)){
                let arr = Object.entries(value.field_value);
                console.log(arr);
                setAllFieldsResponse(value.field_value);
                let newobj = {}
                const newallfields = arr.map(([key,value]) => {  
                  let obj = {}
                  obj.label = key
                  obj.paramname = key
                  return(
                    obj
                  )
                })
                setAllFields(newallfields);
                allFieldsFlag = newallfields.length > 0 ? true : false;
              }
              
              
              if(value.id == 465 && value.field_value != '' && value?.field_value != null){
                // if(allFieldsFlag){
                setNewRecord((prevState) => ({
                  ...prevState,
                  [value.id]: {label: value.field_value, value: value.field_value },
                }));
              // }else{
              //   setNewRecord((prevState) => ({
              //     ...prevState,
              //     [value.id]: {}
              //   }));
              // }
              }  
                // }else{
                //   setNewRecord((prevState) => ({
                //     ...prevState,
                //     [value.id]: value.field_value,
                //   }));
                // }

              
              }

            if (value.id == 52) {
              setChecked(value.field_value == 1 ? true : false);
            }

            // if(value.id == 465 && value.field_value != '' && value?.field_value != null){
            //   debugger
            //   // if(allFieldsFlag){
            //     setNewRecord((prevState) => ({
            //       ...prevState,
            //       [value.id]: {label: value.field_value, value: value.field_value},
            //     }));

            //   // }else{
            //   //   setNewRecord((prevState) => ({
            //   //     ...prevState,
            //   //     [value.id]: {},
            //   //   }));
            //   // }
                
            //   }else{

              
                setNewRecord((prevState) => ({
                  ...prevState,
                  [value.id]: value.field_value,
                }));
              // }
              

            // setNewRecord((prevState) => ({
            //       ...prevState,
            //       [value.id]: value.field_value,
            //     }));

            if(value.id == 135 && value.field_value != ''){
              // setIsDisabled(false);
              setNewRecord((prevState) => ({
                      ...prevState,
                      464 : '',
                    }));
            }
            
          }
        );
      }

      console.log(newRecord , 'ekjsdnajk')
      
      let today = new Date();
      setMaxDate(today);
    }
  }, [education, active]);


  // useEffect(() => {
    const setInitialEduData = () => {
    if (
      typeof education.checksDetails !== "undefined" &&
      education.checksDetails !== null
    ){
      Object.entries(education.checksDetails[0].fields).map(
        ([key, value]) => {
          // if (value.id == 466) {
          //   // setIsOther(value.field_value.toString());
          //   if(value.field_value == '1' || value.field_value == 1){
          //     setUnivType('Other') 
          //     let val = newRecord['135'];
          //     if(val && val != ''){
          //       setNewRecord((prevState) => ({
          //         ...prevState,
          //         "university_board_other" : val,
          //         '135' : { value: "Other", label: "Other" }
          //       }));
          //     }
          //   }else{
          //     setUnivType('') 
          //   }
          // }

          
          // if(value.id == 465 && value.field_value != '' && value?.field_value != null){
            // setNewRecord((prevState) => ({
            //   ...prevState,
            //   [value.id]: {label: value.field_value, value: value.field_value},
            // }));
          // }else{
            setNewRecord((prevState) => ({
              ...prevState,
              [value.id]: value.field_value,
            }));
          // }

          if (value.id == 52) {
            setChecked(value.field_value == 1 ? true : false);
          }
          // if(value.id == 135 && value.field_value != ''){
          //   setIsDisabled(false);
          // }
          if (value.id == 464 && (value?.field_value != '' && value?.field_value != null)){
            let arr = Object.entries(value.field_value);
            console.log(arr);
            setAllFieldsResponse(value.field_value);
            let newobj = {}
            const newallfields = arr.map(([key,value]) => {  
              let obj = {}
              obj.label = key
              obj.paramname = key
              return(
                obj
              )
            })
            setAllFields(newallfields);
          }

          if(value.id == 135){
            setNewRecord((prevState) => ({
              ...prevState,
              [value.id]: value.field_value,
              465: {}
            }));
          }
        }
      );
    }
  }

  console.log(newRecord);

  //on intial load  set data for editing in first tab
  useEffect(() => {
    if (
      typeof education.checksDetails !== "undefined" &&
      education.checksDetails !== null
    ) {
      //here find index of the tab with caseCheckId
      //finding which tab is active
      let foundIndex = null;
      var tabs = document.getElementsByClassName("nav-link tab");
      for (let i = 0; i < tabs.length; i++) {
        if (tabs[i].classList.contains("active")) {
          const dataCaseCh = tabs[i].dataset.casecheckid;
          if (dataCaseCh == active) {
            foundIndex = tabs[i].dataset.index;
          }
        }
      }
      // alert(foundIndex);
      if (active !== null && active !== undefined && foundIndex !== null) {
        tabChange(foundIndex, active);
      }
    }
  }, [education, active]);

  //form validation logic
  const formValidation = (caseCheckId, activeTabIndex) => {
    const errors = {};
    let isError = false;

    // resetting all errors first
    var cols = document.getElementsByClassName("err text-danger");
    for (let i = 0; i < cols.length; i++) {
      cols[i].innerHTML = "";
    }

    let activeTab = activeTabIndex - 1;

    let case_check_id = education.checksDetails[activeTab].case_check_id;

    let field_qualification_degree =
      education.checksDetails[activeTab].fields.qualification_degree;
    //checking if filed coming from api is mandatory
    if (field_qualification_degree.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_qualification_degree.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "qualificationDegree_" + case_check_id;
      let value_element = document
        .getElementsByName("qualificationDegree_" + case_check_id + "_value")[0]
        .value.trim();

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    let field_course_name =
      education.checksDetails[activeTab].fields.course_name;
    //checking if filed coming from api is mandatory
    if (field_course_name.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_course_name.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "courseName_" + case_check_id;
      let value_element;
      if (education.course_auto_suggest) {
        value_element = document
          .getElementById("courseName_" + case_check_id)
          ?.value?.trim();
      } else {
        value_element = document
          .getElementById("courseName_" + case_check_id)
          ?.innerText?.trim();
      }
      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
      // }
    }

    let field_university_board =
      education.checksDetails[activeTab].fields.university_board;
    //checking if filed coming from api is mandatory
    if (field_university_board.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_university_board.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "universityBoard_" + case_check_id;
      let value_element = document
        .getElementById("universityBoard_" + case_check_id)
        .value.trim();

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }

      if(univType == 'Other'){
        let elementErrorId = "err_" + case_check_id + "_university_board_other";
        let elementName = "universityBoardOther_" + case_check_id;
        let value_elementother = document
          .getElementById("universityBoardOther_" + case_check_id)
          .value.trim();

          if (
            value_elementother === undefined ||
            value_elementother === null ||
            value_elementother === ""
          ) {
            document.getElementById(elementErrorId).innerHTML =
              "This field is required.";
            isError = true;
          } 
      }
    }
    if(univType != 'Other'){
      let field_document_type =
      education.checksDetails[activeTab].fields.document_type;
      let fieldId = field_document_type.id;

    if (field_document_type.is_mandatory == 1) {

      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "docType_" + case_check_id;
      let value_element = document
        .getElementById("docType_" + case_check_id + '_value')
        .value;

        if (
          value_element === undefined ||
          value_element === null ||
          value_element === ""
        ) {
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        }     
        if(allFields.length == 0){
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        }  
      }

    allFields && allFields.length > 0 &&
     Object.entries(allFieldsResponse).map(([key,value]) => {
      // console.log(key + '' + value);
      if(value.trim() == '' ){
        setAllResponseError((prev) => ({
          ...prev,
          [key] : 'This field is required'
        }))
        let elementErrorId = key;
        let value = document.getElementById(elementErrorId);
        document.getElementById(elementErrorId).innerHTML =
        "This field is required.";
        isError = true;
      }
    })  
    }

    const cisSlug = "verificationName_" + caseCheckId;
    let field_cis = education.checksDetails[activeTab].fields[cisSlug];

    // let field_qualification_degree = education.checksDetails[activeTab].fields.qualification_degree;

    //checking if filed coming from api is mandatory
    if (field_cis.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_cis.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "cis_" + case_check_id;

      // let value_element = document.getElementsByName('cis_' + case_check_id + "_value")[0].value.trim();
      let value_elements = document
        .getElementById("cis_" + case_check_id)
        .value.trim();
      console.log("fr", value_elements);

      if (
        value_elements === undefined ||
        value_elements === null ||
        value_elements === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    let field_mode_of_qualification =
      education.checksDetails[activeTab].fields.mode_of_qualification;
    //checking if filed coming from api is mandatory
    if (field_mode_of_qualification.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_mode_of_qualification.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "modeOfQualification_" + case_check_id;
      let value_element = document.getElementById(
        "modeOfQualification_" + case_check_id + "_value"
      ).value;

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    if(univType == 'Other'){ 
    let field_college_location =
    education.checksDetails[activeTab].fields.college_location;
  // checking if filed coming from api is mandatory
    if (field_college_location.is_mandatory == 1) {
    //getting field id from api data
    let fieldId = field_college_location.id;
    //identifying which err id element needs to be populated with error
    let elementErrorId = "err_" + case_check_id + "_" + fieldId;
    let elementName = "location_" + case_check_id;
    let value_element = document
      .getElementById("location_" + case_check_id)
      .value.trim();

    if (
      value_element === undefined ||
      value_element === null ||
      value_element === ""
    ) {
      document.getElementById(elementErrorId).innerHTML =
        "This field is required.";
      isError = true;
    }
    }

    let field_batch_start_year =
      education.checksDetails[activeTab].fields.batch_start_year;
    //checking if filed coming from api is mandatory
    if (field_batch_start_year.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_batch_start_year.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "batchStart_" + case_check_id;
      let value_element = document.getElementById(
        "batchStart_" + case_check_id
      ).value;

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    let field_batch_end_year =
      education.checksDetails[activeTab].fields.end_year;
    //checking if filed coming from api is mandatory
    if (field_batch_end_year.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_batch_end_year.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "batchEnd_" + case_check_id;
      let value_element = document.getElementById(
        "batchEnd_" + case_check_id
      ).value;

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    let submitLaterCheckbox = checked;
    // alert(submitLaterCheckbox)

    if (submitLaterCheckbox === false) {
      education.checksDetails[activeTab].required_documents &&
        Object.entries(
          education.checksDetails[activeTab].required_documents
        ).map(([key, value]) => {
          let docCount = document.getElementById(
            "document_" + value.id + "_count_" + case_check_id
          ).value;
          let is_man = document.getElementById(
            "document_" + value.id + "_count_" + case_check_id
          ).dataset.mandatory;

          if (docCount <= 0 && is_man == 1) {
            let elementErrorId =
              "err_document_" + value.id + "_count_" + case_check_id;

            document.getElementById(elementErrorId).innerHTML =
              "This field is required.";
            isError = true;
          }
          if (errorMessage == "true") {
            let elementErrorId =
              "err_document_" + value.id + "_count_" + case_check_id;
            document.getElementById(elementErrorId).innerHTML =
              "File format not valid.";
            isError = true;
          }
        });
    }
  }  

    return isError;
  };

  //form save handler

  const saveHandler = (event, caseCheckId, activetabIndex) => {
    console.log(allResponseError)
    event.preventDefault();
    // const formData2 = {};
    // formData2.formVal1 = formVal.formVal1;
    console.log(caseCheckId);
    const err = formValidation(caseCheckId, activetabIndex);
    // let err = false;
    // const isValidationPassed = Object.keys(err).length === 0;
    console.log(caseCheckId);
    if (err === true) {
      setFormError(err);
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    } else {
      // let verificationSource = document.getElementById(
      //   "cis_" + caseCheckId + "_value"
      // ).value;
      let verificationSourceText = document.getElementById(
        "cis_" + caseCheckId
      ).value;

      const additonalData = {
        // "verificationCourse": "4",
        verificationName: verificationSourceText,
        // verificationSource: parseInt(verificationSource),
        verificationSourceText: verificationSourceText,
        // "otherVerificationSource": ""
      };

      const recordData = {};
      recordData.case_check_id = caseCheckId;
    
      let obj = {}
      if(univType != 'Other'){
        if(newRecord[465].label != '' && allFields.length > 0){

          saveDigilockerPayload();
          obj = {
            group: "education",
            // "13": "12\/2014",
            // "69": "3",
            // "11": "3333",
            // "12": "",
            // "138": "test",
            // "52": "1",
            ...newRecord,
            ...additonalData,
            digiLockerFields:allFieldsResponse,
            orgId:allFields[0].org_id,
            is_other: isOther
          }
        }else{
          setFormError(err);
          window.scroll({ top: 0, left: 0, behavior: "smooth" });
        }
      }else{
        obj = {
          group: "education",
          // "13": "12\/2014",
          // "69": "3",
          // "11": "3333",
          // "12": "",
          // "138": "test",
          // "52": "1",
          ...newRecord,
          ...additonalData,
          is_other:isOther
        };
      }
      // debugger
      // recordData.check_data = { [caseCheckId]: { "group": "education", ...newRecord, ...additonalData } };
      // if(obj[135] == ""){
        let case_check_id = education.checksDetails[activeTab].case_check_id;
        let value_element = document
        .getElementById("universityBoard_" + case_check_id)
        .value.trim();
        if(value_element != ""){
          obj[135] = value_element;
        }
      // }
      console.log(obj);
      recordData.check_data = { [caseCheckId]: obj };
      console.log(obj);
      localStorage.setItem('recordData' , JSON.stringify(recordData));
      dispatch(saveEducation(recordData));
    }
  };
  //setting loader while saving
  const storeEducationSave = useSelector((state) => state.educationSave);
  const {
    educationSaveData,
    loading: saveLoading,
    error: saveError,
  } = storeEducationSave;
  console.log(educationSaveData);
  useEffect(() => {
    if (typeof saveLoading !== "undefined" && saveLoading !== null) {
      if (saveLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        //  reRenderAgain();
      }
    }
  }, [saveLoading]);

  //redirecting after saving
  // useEffect(()=>{
  //   if(digiResult==true){
  //     navigate(`/case-initiation/profile-preview/${reference}`);
  //   }
  // },[educationSaveData, storeEducationSave])
  useEffect(() => {
    // if (
    //   typeof educationSaveData.reference_number !== "undefined" &&
    //   educationSaveData.reference_number !== null &&
    //   digiResult==false
    // ) {
    //   dispatch(getData());
    //   props.reSetData();
    //   reRenderAgain2();

    //   setIsLoading(true);

    //   const group = educationSaveData.group
    //     ? educationSaveData.group.group_id
    //     : "";
    //   const hasNextCheck = educationSaveData.nextCheck != "" ? true : false;
    //   const reference = educationSaveData.reference_number;
    //   if(educationSaveData.isDigilocker){
    //     setShowDigiPopup(true);
    //     setIsLoading(false);
    //     window.scrollTo(0, 0);
    //   }
      // else
      // if (!hasNextCheck) {
      //   if (group == "profile_preview") {
      //     navigate(`/case-initiation/profile-preview/${reference}`);
      //     dispatch(deleteSaveEducation());
      //   } else if (typeof group != "undefined" && group != "") {
      //     navigate(`/case-initiation/check-detail/${reference}/${group}`);
      //     dispatch(deleteSaveEducation());
      //   }
      // } else {
      //   navigate(
      //     `/case-initiation/check-detail/${reference}/3/${educationSaveData.nextCheck}`
      //   );
      //   dispatch(deleteSaveEducation());
      //   setIsLoading(false);
      //   window.scrollTo(0, 0);
      // }
    // }
  }, [educationSaveData, storeEducationSave]);

  // add education click handler
  const handleEducationAddClick = (e) => {
    e.preventDefault();
    setNewRecord({});
    dispatch(addEducation());
  };

  const addEducationStoreData = useSelector((state) => state.educationAdd);
  const {
    educationAddData,
    loading: addLoad,
    error: addError,
  } = addEducationStoreData;
  const [educationAddedState, setEducationAddedState] = useState();

  //after add handler modify existing main state
  useEffect(() => {
    if (
      typeof educationAddData.data !== "undefined" &&
      educationAddData.data !== null
    ) {
      // const newEducation = { ...education };
      // newEducation['checksDetails'][educationAddData.data.checksCount - 1] = educationAddData.data.checksDetails[0];
      // setEducation(newEducation);
      // setEducationAddedState(1);
      // reRenderAgain();
      if(!education.is_digilocker_enabled){
      navigate(
        `/case-initiation/check-detail/${reference}/3/${educationAddData.data.checksDetails[0].case_check_id}`
      );
      }
      reRenderAgain2();
    }
  }, [educationAddData]);

  //on add handler initiate loader
  useEffect(() => {
    if (typeof addLoad !== "undefined" && addLoad !== null) {
      if (addLoad === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        reRenderAgain2();
      }
    }
  }, [educationAddData]);

  useEffect(() => {
    localStorage.setItem("reference", reference);
    const showDigi = localStorage?.getItem('digiResponse');
    showDigi==1?setDigiResult(true):setDigiResult(false)
  }, []);

  const closeRemovePopup = () => {
    setShowRemovePopup(false);
  };

  const proceedRemove = () => {
    if (checkIdToBeRemoved) {
      dispatch(removeEducation(checkIdToBeRemoved));
      reRenderAgain();
      setCheckIdToBeRemoved(null);
      setShowRemovePopup(false);
    }
  };

  const closeRemoveDigiPopup = () => {
    setShowDigiRemovePopup(false);
  };

  const proceedDigiRemove = () => {
    if (selectedCaseCheckId) {
      dispatch(removeEducation(selectedCaseCheckId));
      reRenderAgain2();
      setCheckIdToBeRemoved(null);
      setShowDigiRemovePopup(false);
    }
  };

  //execute call api on remove hanler
  const handleEducationRemoveClick = (e, caseCheckId) => {
    // alert(caseCheckId);
    // setShowModal(1);
    e.preventDefault();
    // dispatch(removeEducation(caseCheckId));
    setCheckIdToBeRemoved(caseCheckId);
    setShowRemovePopup(true);

    // window.location.reload(false);
    //  reRenderAgain();
  };

  // setting loader while saving
  const storeEducationRemove = useSelector((state) => state.educationRemove);
  const {
    educationRemoveData,
    loading: removeLoading,
    error: removeError,
  } = storeEducationRemove;
  useEffect(() => {
    if (typeof removeLoading !== "undefined" && removeLoading !== null) {
      if (removeLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [removeLoading]);

  //after add handler remove active from all tabs and append it on last
  useEffect(() => {
    if (
      typeof educationRemoveData.case_check_id !== "undefined" &&
      educationRemoveData.case_check_id !== null
    ) {
      dispatch(getData());

      props.reSetData();

      // debugger;
      navigate(`/case-initiation/check-detail/${reference}/3`);
      reRenderAgain2();

      // reRenderAgain();
    }
  }, [educationRemoveData, storeEducationRemove]);

  const errorCheck = (data) => {
    console.log(data);
    setErrorMessage(data);
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };

  //functions for new form

  const closeDigiPopup = () => {
    setShowDigiPopup(false);
  };

  const handleSaveData = (e) => {
    e.preventDefault();
    // let digilockerObject = JSON.parse(localStorage.getItem("digiObj"));
    // let finalData = {}
    // let convertedData = Object.values(digilockerObject);
    // let convertedData = data.map((obj, item) => {
    //   let key = Object.keys(item)[0];
    //   obj[key] = item;
    //   // finalData = {...obj};
    //   return obj;
    // }, {});
    // console.log(convertedData);
    // console.log(allFields);
    // if(Object.entries(convertedData).length > 0 ){
      dispatch(verifyDigiLockerDocuments(getDigilockerUrl));
    // }else{
    // setShowDigiPopup(false);
    // }
  };
  

  const getDigilockerUrl = (url,trans_id) => {
    setShowDigiPopup(false);
    localStorage.setItem('digiTransId', JSON.stringify(trans_id));
    window.location.href = url;
  };

  const saveDigilockerPayload = () => {
    // digiLockerFields:allFieldsResponse,
    // orgId:allFields[0].org_id
    let digilockerObject = JSON.parse(localStorage.getItem("digiObj"));
    let obj = {};
    let obj1 = {};
    let finalObj = {};
    let obj2 = {};
    if(univType != 'Other'){
      let id = allFields[0]?.org_id;
      let key = allFields[0]?.doc_type;
      if(id == undefined || key == undefined){
        let data = newRecord[465];
        id = data.value.new_org_id;
        key = data.value.doc_type;
      }
      obj1[key] = allFieldsResponse;
      obj[id] = obj1;
      obj2[`education-${activeTabEdu}`] = obj;
      console.log(obj2);
      console.log(obj);
      console.log(allFieldsResponse);
      if (digilockerObject) {
        finalObj = { ...digilockerObject, ...obj2 };
      } else {
        finalObj = obj2;
      }
    }else{
      if(digilockerObject){
        finalObj = digilockerObject;
      }
    }
    console.log(finalObj);
    localStorage.setItem('digiObj', JSON.stringify(finalObj));

  }

  const checkValueList = (options) => {
    if(Array.isArray(options)){
      let flag = true
      options.map((item) => {
        if(item.length != 4){
          flag = false;
          return false
        }
        // flag = item.length != 4 ? fals
      })
      return flag;
    }
    return false
  }

  const yearSelectHandler = (value, key) => {
    console.log(value.getYear() + 1900);
    // var cols = document.getElementById().err_id);
    // cols.innerHTML = "";
    
    //this is state is for validation purpose
    // setNewValidationRecord((prevState) => ({
    //   ...prevState,
    //   [value[0].name]: value[0].value,
    // }));
    let val = value.getYear() + 1900
    setAllFieldsResponse((prev) => ({
      ...prev,
      [key]: val.toString(),
    }));
    setAllResponseError((prev) => ({
      ...prev,
      [key]: '',
    }));
  }

  const colourStyles = {
    control: styles => ({ ...styles,  zIndex: -999  }),
    // option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    //   // const color = chroma(data.color);
    //   return {
    //     ...styles,
    //     // backgroundColor: isDisabled ? 'red' : 'blue',
    //     // color: '#FFF',
    //     // cursor: isDisabled ? 'not-allowed' : 'default',
    //     position: 'absolute',
    //     zIndex: 100
    //   };
    // },
  };

  // const handleCheckSaveData = (e) => {
  //   e.preventDefault()
  // }
  // console.log(allFields);
  // console.log(allFieldsResponse);
  console.log(newRecord);
console.log(allResponseError)

// new states
const [activeTab1, setActiveTab1] = useState(0);
const [allTabsData , setAllTabData] = useState([]);

//   const handleContinue = () => {
//     // Check if all required fields in the current tab are filled
//     const currentTab = tabs[activeTab].content;
//     const allFieldsFilled =
//       currentTab.props.value &&
//       Object.values(currentTab.props.value).every((val) => val.trim() !== "");

//     if (allFieldsFilled) {
//       // Move to the next tab
//       setActiveTab1((prevTab) => prevTab + 1);
//     } else {
//       // Show an error message or highlight the unfilled fields
//       alert("Please fill out all fields before continuing.");
//     }
//   };

  const value = {
    // Define your value object here
    // For example:
    school: "Your School Name",
    degree: "Your Degree",
    fieldOfStudy: "Your Field of Study",
    startDate: "Your Start Date",
    endDate: "Your End Date",
  };

//   const tabs = [
//     { label: "Education 1", content: <Education1 value={value} /> },
//     { label: "Education 2", content: <Education2 /> },
//     { label: "Education 3", content: <Education3 /> },
//   ];

const createTabs = (data) => {
    
    // console.log(education?.checksDetails.length);
    const tabData = Object.values(data)?.map((item) => {
        return item
    })
    console.log(tabData);
    setAllTabData(tabData);

}

useEffect(() => {
  console.log("selected tab case check Id...",selectedCaseCheckId)
},[selectedCaseCheckId])


  return (
    <>
      {/* {(loading || loadRS) && <Loader />} */}
      {/* {isLoading && <Loader />} */}
      {/* {catchIfAnyStatusIsNotCompleted === 0 &&
        <button className="btn btn-primary add-btn" style={{ minWidth: '170' + 'px' }} onClick={(e) => handleEducationAddClick(e)}>+ Add Education</button>
      } */}

      {/* {showAddPopup == true && catchIfAnyStatusIsNotCompleted != 1 && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeAddPopup}
          title="Add Education"
          description="Are you sure you want to add another Education?"
          proceedHandler={proceedAdd}
          isAdd={true}
          checkStatus={catchIfAnyStatusIsNotCompleted}
        />
      )} */}
      {showDigiRemovePopup == true && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeRemoveDigiPopup}
          title="Remove Education"
          description="Are you sure you want to remove this education?"
          proceedHandler={proceedDigiRemove}
          isAdd={false}
        />
      )}
      {/* {showAddPopup == true && catchIfAnyStatusIsNotCompleted == 1 && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeAddPopup}
          title="Add Education"
          description="Save the existing education, before adding a new one"
          proceedHandler={proceedAdd}
          isAdd={false}
          checkStatus={catchIfAnyStatusIsNotCompleted}
        />
      )}

      {showRemovePopup == true && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeRemovePopup}
          title="Remove Education"
          description="Are you sure you want to remove this education?"
          proceedHandler={proceedRemove}
          isAdd={false}
        />
      )} */}

      {showDigiPopup && (
        <DigilockerPopup
          showModalBox={1}
          closePopup={closeDigiPopup}
          proceedHandler={proceedRemove}
          isAdd={false}
          handleSaveData={handleSaveData}
        />
      )} 
      {/* <div className="d-flex justify-content-between align-items-center">
        <ul className="nav nav-tabs address-tabs" id="myTab" role="tablist">
          {education.checksDetails &&
            Object.entries(education.checksDetails).map(([key, value]) => {
              const index = parseInt(key) + 1;
              const caseCheckId = value.case_check_id;
              const caseCheckStatus = value.check_status;

              let activeClass = "";
              if (typeof active !== "undefined") {
                if (active == caseCheckId) {
                  activeClass = "show active";
                }
              } else if (index === 1 && !digiResult) {
                activeClass = "active";
              }

              let completeClass = "";
              console.log(caseCheckStatus);
              if ((caseCheckStatus === 2 || caseCheckStatus === 3) && !digiResult) {
                completeClass = "completed";
              }
              if(digiResult){
                completeClass = '';
                activeClass = '';
              }

              return (
                <li className={`nav-item ${completeClass}`} key={key}>
                {!digiResult ? 
                  <a
                    className={`tab nav-link ${activeClass} ${completeClass}`}
                    id={`education-tab-${index}`}
                    data-toggle="tab"
                    href={`#education-${index}`}
                    role="tab"
                    aria-controls={`education-${index}`}
                    aria-selected="true"
                    data-index={index - 1}
                    data-caseCheckId={caseCheckId}
                    onClick={() => tabChange(key, caseCheckId)}
                  >
                    {(caseCheckStatus === 2 || caseCheckStatus === 3) && (
                      <i class="fas fa-check-circle mr-1"></i>
                    )}
                    Education {index}
                  </a>
                  :
                  <a
                    className={`tab nav-link ${activeClass} ${completeClass}`}
                  >
                    {(caseCheckStatus === 2 || caseCheckStatus === 3) && (
                      <i class="fas fa-check-circle mr-1"></i>
                    )}
                    Education {index}
                  </a>
                }
                 </li>
              );
            })}
            { digiResult && <li className={`nav-item completed`}>
                  <a
                    className={`tab nav-link active completed`}
                   
                  >
                      <i class="fas fa-check-circle mr-1"></i>
                    
                    Upload Documents
                  </a>
                </li>}
        </ul>
      </div> */}
      {/* <hr /> */}

      {/* {digiResult?
      <div className="tab-content d-none" id="myTabContent">
      {/* <EducationDigilocker 
      education={education}
      handleSubmitForPreview={handleSubmitForPreview}
      /></div> */}
    {/*  */}

      {isLoading && <Loader />}
    
      {/* <div className="container-fluid w-100 p-2">
        <div className="headSection">
          <div className="d-flex justify-content-between align-items-start px-3">
            <div className="headings">
              <div className="head">Education</div>
              <div className="subHead">
                Add your highest education degree/certificate/all marksheets
              </div>
            </div>
          <SingleTab tabs={tabs} activeTab={activeTab1} />
            <div className="btn btn-primary" onClick={handleContinue}>
              + Add Qualification
            </div>
          </div>
        </div>
      </div> */}

      <div>
        {/* Multiple Tab Design  */}
        <MultiTabEdu checkName={'Education'} tabs={allTabsData} activeTab={activeTab1} 
                     educationData={education} setSelectedCaseCheckId={setSelectedCaseCheckId} 
                     reference={reference} reSetData={props.reSetData} reRenderAgain2={props.reRenderAgain2} />

      </div>
    
    </>
  );
};
export default MainFormDigiLockerNew;
